"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpsellSimpleRoute = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const getTransformFromLocalizedField_1 = require("../getTransformFromLocalizedField");
const LocalizedField_1 = require("../models/LocalizedField");
const GeoPointType_1 = require("./GeoPointType");
let UpsellSimpleRoute = class UpsellSimpleRoute {
    routeId;
    isOtherDirection;
    originPosition;
    destinationPosition;
    originLocationName;
    originLocationId;
    destinationLocationName;
    destinationLocationId;
    originLocationImagePath;
    destinationLocationImagePath;
    order;
    isToOrigin; // is from destination when false
    numberOfOrders;
    numberOfOrdersInOtherDirection;
    destinationLocationPerexLocalized = new LocalizedField_1.LocalizedField();
    destinationLocationPerex;
    originLocationPerexLocalized = new LocalizedField_1.LocalizedField();
    originLocationPerex;
    originLocationNameLocalized = new LocalizedField_1.LocalizedField();
    originLocationTitleLocalized = new LocalizedField_1.LocalizedField();
    originLocationDescriptionLocalized = new LocalizedField_1.LocalizedField();
    destinationLocationNameLocalized = new LocalizedField_1.LocalizedField();
    destinationLocationTitleLocalized = new LocalizedField_1.LocalizedField();
    destinationLocationDescriptionLocalized = new LocalizedField_1.LocalizedField();
};
exports.UpsellSimpleRoute = UpsellSimpleRoute;
__decorate([
    (0, type_graphql_1.Field)(() => String),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UpsellSimpleRoute.prototype, "routeId", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => Boolean),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], UpsellSimpleRoute.prototype, "isOtherDirection", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => GeoPointType_1.GeoPointType),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", GeoPointType_1.GeoPointType)
], UpsellSimpleRoute.prototype, "originPosition", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => GeoPointType_1.GeoPointType),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", GeoPointType_1.GeoPointType)
], UpsellSimpleRoute.prototype, "destinationPosition", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => String),
    (0, class_validator_1.Length)(1, 64),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UpsellSimpleRoute.prototype, "originLocationName", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => String),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UpsellSimpleRoute.prototype, "originLocationId", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => String),
    (0, class_validator_1.Length)(1, 64),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UpsellSimpleRoute.prototype, "destinationLocationName", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => String),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UpsellSimpleRoute.prototype, "destinationLocationId", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => String),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UpsellSimpleRoute.prototype, "originLocationImagePath", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => String),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UpsellSimpleRoute.prototype, "destinationLocationImagePath", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], UpsellSimpleRoute.prototype, "order", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => Boolean, { nullable: true }),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], UpsellSimpleRoute.prototype, "isToOrigin", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int, { nullable: true }),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], UpsellSimpleRoute.prototype, "numberOfOrders", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int, { nullable: true }),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], UpsellSimpleRoute.prototype, "numberOfOrdersInOtherDirection", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], UpsellSimpleRoute.prototype, "destinationLocationPerexLocalized", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)((0, getTransformFromLocalizedField_1.getTransformFromLocalizedField)("destinationLocationPerexLocalized")),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UpsellSimpleRoute.prototype, "destinationLocationPerex", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], UpsellSimpleRoute.prototype, "originLocationPerexLocalized", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)((0, getTransformFromLocalizedField_1.getTransformFromLocalizedField)("originLocationPerexLocalized")),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UpsellSimpleRoute.prototype, "originLocationPerex", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], UpsellSimpleRoute.prototype, "originLocationNameLocalized", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], UpsellSimpleRoute.prototype, "originLocationTitleLocalized", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], UpsellSimpleRoute.prototype, "originLocationDescriptionLocalized", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], UpsellSimpleRoute.prototype, "destinationLocationNameLocalized", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], UpsellSimpleRoute.prototype, "destinationLocationTitleLocalized", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], UpsellSimpleRoute.prototype, "destinationLocationDescriptionLocalized", void 0);
exports.UpsellSimpleRoute = UpsellSimpleRoute = __decorate([
    (0, type_graphql_1.ObjectType)("UpsellSimpleRoute"),
    (0, class_transformer_1.Exclude)()
], UpsellSimpleRoute);
//# sourceMappingURL=UpsellSimpleRoute.js.map